import { useState } from "react";
import { Gift, BookOpen, GraduationCap } from "lucide-react";
import EmailDoctorModal from "@/components/site/EmailDoctorModal";

const OPTIONS = [
  {
    key: "tutoring",
    icon: GraduationCap,
    title: "Gift a Tutoring Session",
    price: "$50",
    note: "One hour of one-on-one math help with Dr. Louden — for a student you believe in.",
    message: "Hello, I would like to purchase a GIFT tutoring session ($50) for someone. Please contact me with the details.\n\nMy name:\nRecipient's name:\nOccasion:",
  },
  {
    key: "book",
    icon: BookOpen,
    title: "Gift a Book",
    price: "From $15",
    note: "Any title from The Library, sent with your personal note — a gift that keeps speaking.",
    message: "Hello, I would like to purchase a book as a GIFT. Please contact me with the details.\n\nMy name:\nBook title:\nRecipient's name:\nGift note to include:",
  },
];

export default function GiftLearning() {
  const [gift, setGift] = useState(null);

  return (
    <section data-testid="gift-learning" className="mt-14">
      <span className="text-xs uppercase tracking-[0.4em] text-[#C9A227]">Give the Gift of Learning</span>
      <h2 className="mt-3 font-display text-4xl md:text-6xl uppercase tracking-tight text-white">
        Gift Cards
      </h2>
      <p className="mt-4 max-w-2xl text-base text-white/60">
        Know a student who needs a breakthrough, or a reader who loves a powerful book? Give them a
        session or a title from the collection — Dr. Louden will arrange everything personally.
      </p>
      <div className="mt-10 grid gap-6 md:grid-cols-2">
        {OPTIONS.map((o) => (
          <div key={o.key} data-testid={`gift-card-${o.key}`}
            className="rounded-2xl border border-[#C9A227]/25 bg-white/[0.03] p-7 transition-colors hover:border-[#C9A227]/60">
            <o.icon size={22} className="text-[#C9A227]" />
            <h3 className="mt-4 font-display text-2xl uppercase text-white">{o.title}</h3>
            <p className="mt-1 text-sm font-semibold text-[#C9A227]">{o.price}</p>
            <p className="mt-3 text-sm leading-relaxed text-white/55">{o.note}</p>
            <button onClick={() => setGift(o)} data-testid={`gift-request-${o.key}`}
              className="magnetic-btn mt-6 inline-flex items-center gap-2 rounded-full bg-[#C9A227] px-6 py-2.5 text-xs font-bold uppercase tracking-widest text-black transition-colors hover:bg-white">
              <Gift size={14} /> Request This Gift
            </button>
          </div>
        ))}
      </div>
      <EmailDoctorModal
        open={!!gift}
        onClose={() => setGift(null)}
        heading="Request a Gift"
        subtext="Tell us the details — Dr. Louden will confirm your gift personally by email."
        initialMessage={gift?.message || ""}
      />
    </section>
  );
}
